import axios, { AxiosError, AxiosInstance } from 'axios';

import { SURVEY_DATA_MANAGER_TENANT_HEADER, SurveyDataManagerApiError } from '../contracts/common';
import { getTenantIdFromStorage } from 'utils/tenant';

const AUTH_TOKEN_STORAGE_KEY = 'token';

function getSurveyDataManagerBaseUrl(): string | undefined {
  const configured = process.env.REACT_APP_SURVEY_DATA_MANAGER_API_URL?.trim();
  if (configured && configured !== 'undefined' && configured !== 'null') {
    return configured.replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return undefined;
  }
  return undefined;
}

const surveyDataManagerClient: AxiosInstance = axios.create({
  baseURL: getSurveyDataManagerBaseUrl(),
});

surveyDataManagerClient.interceptors.request.use((config) => {
  if (typeof window === 'undefined') {
    return config;
  }

  const token = window.localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  const tenantId = getTenantIdFromStorage();
  if (tenantId && !config.headers?.[SURVEY_DATA_MANAGER_TENANT_HEADER]) {
    config.headers = config.headers ?? {};
    config.headers[SURVEY_DATA_MANAGER_TENANT_HEADER] = tenantId;
  }

  return config;
});

export function toSurveyDataManagerApiError(error: unknown): SurveyDataManagerApiError {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<Partial<SurveyDataManagerApiError>>;
    const responseBody = axiosError.response?.data;
    const status = axiosError.response?.status ?? 0;

    return {
      status,
      code: responseBody?.code,
      message:
        responseBody?.message ??
        axiosError.message ??
        'Unexpected error reconnecting to the Survey Data Viewer API.',
      details: responseBody?.details,
    };
  }

  if (error instanceof Error) {
    return { status: 0, message: error.message };
  }

  return { status: 0, message: 'Unknown error.' };
}

export { surveyDataManagerClient };
